import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
const GOLD = '#d8b878';
export function BookDescription() {
  return <section className="relative overflow-hidden bg-matrix-black py-24 md:py-36 px-5 md:px-8" data-id="element-62">
      {/* Perspective board — lines converging toward a golden horizon */}
      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" data-id="element-63">
        {/* Golden horizon glow (vanishing point) */}
        <motion.div className="absolute left-1/2 top-[42%] h-[30vh] w-[80vw] max-w-3xl -translate-x-1/2 blur-3xl" style={{
        background: 'radial-gradient(ellipse at center, rgba(216,184,120,0.18) 0%, rgba(0,255,65,0.06) 45%, transparent 72%)'
      }} animate={{
        opacity: [0.5, 0.85, 0.5]
      }} transition={{
        duration: 7,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-64" />
        {/* The board grid receding in perspective */}
        <div className="absolute bottom-0 left-1/2 h-[55%] w-[160%] -translate-x-1/2 opacity-[0.16]" style={{
        transform: 'translateX(-50%) perspective(520px) rotateX(62deg)',
        transformOrigin: 'bottom center',
        backgroundImage: 'linear-gradient(rgba(216,184,120,0.55) 1px, transparent 1px), linear-gradient(90deg, rgba(0,255,65,0.45) 1px, transparent 1px)',
        backgroundSize: '52px 52px',
        maskImage: 'linear-gradient(to top, black 0%, transparent 85%)',
        WebkitMaskImage: 'linear-gradient(to top, black 0%, transparent 85%)'
      }} data-id="element-65"></div>
        {/* Vignette for depth */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_40%,_rgba(0,0,0,0.8)_100%)]" data-id="element-66"></div>
      </div>

      <div className="relative z-10 max-w-2xl mx-auto text-center" data-id="element-67">
        <motion.span initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="inline-block font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-7" style={{
        color: 'rgba(216,184,120,0.7)'
      }} data-id="element-68">
          La revelación
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.85,
        delay: 0.05
      }} className="font-cinzel text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-matrix-cream leading-[1.18] mb-10 md:mb-12 drop-shadow-[0_0_22px_rgba(245,230,200,0.18)]" data-id="element-69">
          No estás perdido.{' '}
          <span className="italic" style={{
          color: GOLD,
          textShadow: '0 0 30px rgba(216,184,120,0.4)'
        }} data-id="element-70">
            Estás empezando a ver el tablero.
          </span>
        </motion.h2>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.12
          }
        }
      }} className="space-y-5 md:space-y-6 text-[15px] md:text-lg text-matrix-white/80 font-light leading-[1.95]" data-id="element-71">
          {['Durante mucho tiempo quizá pensaste que el problema eras tú.', 'Que había algo en ti que no encajaba. Que no entendías por qué repetías ciclos, emociones, relaciones o decisiones que no te llevaban a donde querías.', 'Pero a veces el problema no es tu vida.', 'A veces el problema es que nadie te enseñó a mirar el juego completo.', 'Este ebook es una invitación a detenerte, observar con otros ojos y reconocer que tal vez no estás fallando: tal vez estás empezando a despertar.'].map((p, i) => <motion.p key={i} variants={{
          hidden: {
            opacity: 0,
            y: 16
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.6
            }
          }
        }} className={i === 2 || i === 3 ? 'text-matrix-white/65 italic' : ''} data-id="element-72">
              {p}
            </motion.p>)}
        </motion.div>

        {/* Closing phrase — memorable idea */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="mt-12 md:mt-16" data-id="element-73">
          <div className="w-px h-10 bg-gradient-to-b from-transparent via-[rgba(216,184,120,0.5)] to-transparent mx-auto mb-8" data-id="element-74"></div>
          <p className="font-cinzel italic text-xl sm:text-2xl md:text-3xl leading-[1.4]" style={{
          color: GOLD,
          textShadow: '0 0 26px rgba(216,184,120,0.5), 0 0 60px rgba(216,184,120,0.2)'
        }} data-id="element-75">
            Ver el tablero cambia la forma en que entiendes tus pasos.
          </p>
        </motion.div>
      </div>
    </section>;
}